// extracted by mini-css-extract-plugin
export var root = "styles-module--root--1S7B2";
export var contentHolder = "styles-module--content-holder--2Fjpg";
export var navigation = "styles-module--navigation--1bDl2";
export var active = "styles-module--active--3DDP0";
export var divider = "styles-module--divider--NzTs0";